import Message from './Message';
import RedeemConfigStore from '../../stores/RedeemConfigStore';
import {getLocale} from '@epic-core/common';
import {ErrorMessage} from 'epic-react-common';

export default ErrorMessage(RedeemConfigStore, getLocale, Message);
